import { NodeModel, StrictNodeModel } from '../../types';

import { getPathSegment } from './getPathSegment';

export function standardizeNode(
  node: NodeModel,
  ctx: {
    path: string;
    color: number;
    index: number;
  },
): StrictNodeModel {
  const pathSegment = getPathSegment(node, ctx.index);
  const key = node.key ?? `${ctx.path}/${pathSegment}`;
  const color = node.color ?? ctx.color;
  // TODO verify that key is a valid icon slug
  const icon =
    node.icon ?? ({ image: key.slice(1) } as StrictNodeModel['icon']);
  const ariaLabel = normalizeAriaLabel(
    typeof node.label === 'string' ? node.label : node.label.aria,
  );
  let href =
    node.href ??
    (!node.children && node.moduleSlug
      ? `/modules/games/${node.moduleSlug}`
      : undefined);
  let dataPath = node.dataPath;

  if (!dataPath && node.moduleSlug && !node.children?.length) {
    let dataKey = node.moduleSlug;
    if (node.moduleVariant) dataKey += node.moduleVariant;
    dataPath = ['games', dataKey];
  }

  if (
    node.moduleVariant !== undefined &&
    href &&
    href.indexOf('moduleVariant') < 0
  ) {
    href += `?moduleVariant=${node.moduleVariant}`;
  }

  return {
    ...node,
    key,
    ariaLabel,
    href,
    icon: typeof icon === 'object' ? icon : { image: icon, text: undefined },
    color,
    filterRoot: node.filterRoot
      ? standardizeNode(node.filterRoot, { path: '', color, index: 0 })
      : undefined,
    children:
      node.children?.map((c, index) =>
        standardizeNode(c, {
          path: key,
          color,
          index,
        }),
      ) ?? [],
  };
}

function normalizeAriaLabel(label: string): string {
  return label.replace(/\s+/g, ' ').trim();
}
